import { Panel } from 'react-resizable-panels';

import { useWorkspace } from '../state/workspace.js';
import { ControllerOverlay } from './animator/ControllerOverlay.js';
import { MixerOverlay } from './audio/MixerOverlay.js';
import { Editor } from './Editor.js';
import { Explorer } from './Explorer.js';
import { Git } from './Git.js';
import { Tabs } from './Tabs.js';
import { Terminal } from './Terminal.js';
import { UiDocOverlay } from './ui-editor/UiDocOverlay.js';
import { IconButton } from './ui/controls.js';
import { Icon } from './ui/icons.js';
import { Handle, SplitGroup } from './ui/layout.js';
import { WEBSITE } from '../lib/edition.js';
import { WebsiteNotice } from './website/PublishPanel.js';

/** VS Code-style code view: explorer | tabs + Monaco / terminal; or Git. */
export function CodeTab({ projectId, projectName }: { projectId: number; projectName: string }) {
  const side = useWorkspace((s) => s.codeSide);
  const setSide = useWorkspace((s) => s.setCodeSide);
  const hasTabs = useWorkspace((s) => s.tabs.length > 0);

  return (
    <div className="tab-body tab-code">
      <nav className="code-rail" aria-label="Code views">
        <IconButton icon="explorer" title="Explorer" active={side === 'explorer'} size={18} onClick={() => setSide('explorer')} />
        <IconButton icon="git" title="Source Control" active={side === 'git'} size={18} onClick={() => setSide('git')} />
      </nav>
      {side === 'git' ? (
        <div className="pane pane-full code-git">
          <div className="side-head">Source Control</div>
          {!WEBSITE && <Git projectId={projectId} />}
        </div>
      ) : (
        <SplitGroup id="code-h" orientation="horizontal" fallback={{ side: 20, main: 80 }} className="workspace-body">
          <Panel id="side" minSize={180} className="pane workspace-side">
            <div className="side-head">{projectName}</div>
            <Explorer />
          </Panel>
          <Handle orientation="vertical" />
          <Panel id="main" minSize={300} className="pane pane-main">
            <SplitGroup id="code-v" orientation="vertical" fallback={{ editor: 70, bottom: 30 }}>
              <Panel id="editor" minSize={120} className="pane pane-editor">
                <Tabs />
                <Editor />
                <ControllerOverlay />
                <UiDocOverlay />
                <MixerOverlay />
                {!hasTabs && (
                  <div className="editor-welcome">
                    <Icon name="code" size={30} />
                    <strong>No file open</strong>
                    <span className="muted">
                      Pick a file in the explorer or press <kbd className="kbd">Ctrl</kbd> <kbd className="kbd">P</kbd>
                    </span>
                  </div>
                )}
              </Panel>
              <Handle orientation="horizontal" />
              <Panel id="bottom" minSize={60} collapsible className="pane pane-bottom">
                {WEBSITE ? <WebsiteNotice what="The terminal" /> : <Terminal />}
              </Panel>
            </SplitGroup>
          </Panel>
        </SplitGroup>
      )}
    </div>
  );
}
